module.exports = __webpack_public_path__ + "img/gears-icons.9d09b683.svg";